
import React from 'react'
import { Helmet } from 'react-helmet';
import { useMediaQuery } from 'react-responsive'
import { useNavigate, Link } from "react-router-dom"
import Button from '../../components/Button'
import Return from '../../components/Forum/Return'
import CommentIcon from '../../images/comment.svg'
import LikeIcon from '../../images/like.svg'

export default function Post56() {

  const tabletBreakpoint = useMediaQuery({ query: '(min-width: 768px)' })

  const navigate = useNavigate()

  React.useEffect(() => { 
    window.scrollTo(0, 0)
  }, [])


  return (

    <div className="top-margin-s">

      <Helmet>
        <title>Quem tem diabetes pode comer cenoura?</title>
        <meta 
          name="description" 
          content="Quem tem diabetes pode comer cenoura?"/>
      </Helmet>

      <div className={(tabletBreakpoint) ? 
        "container-simple-tablet" : "container-simple"}>
        <div className="top-margin-s bottom-margin-s">
          <Return to='/forum' />
        </div>
        <div className="bottom-margin-s">
          <p className="secondary-text bottom-margin-xs">
            Joana Ling &#183; 10/08/2024
          </p>
        </div>


        <p className="body content bottom-padding-s">
            Quem tem diabetes pode comer cenoura?
        </p>


        <div className="post-stats bottom-padding-xs">
          <button onClick={()=>{navigate('/forum/56')}} className="svg-btn">
            <div className="post-useful-info">
              <div> 
               <img src={LikeIcon} alt="Button indicating if you found this useful" />
              </div>
              <p className="secondary-text">
                  1 pessoa achou útil
              </p>
            </div>
          </button>

          <div className="post-useful-info"> 
            <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
            <p className="secondary-text">
              1 comentário
            </p>
          </div> 
        </div>
        <div className="top-padding-xs">

              <div className="comment-background comment">
                <p className="body comment-fixed">
                  Oi, Joana!<br/><br/>Sim, quem tem diabetes pode comer cenoura! 😊 As cenouras são consideradas vegetais de baixo índice glicêmico, o que significa que elas não causam um aumento rápido nos níveis de açúcar no sangue. Elas são uma ótima fonte de vitaminas e fibras.<br/><br/>No entanto, como qualquer alimento, é importante comer com moderação e dentro de uma dieta equilibrada. Se você tiver alguma dúvida específica sobre sua dieta, é sempre bom conversar com seu médico ou nutricionista. Eles podem te ajudar a fazer escolhas que serem ainda melhores para sua saúde.<br/><br/>Se precisar de mais alguma coisa, estou aqui para ajudar!<br/><br/>Abraços,<br/>Florence
                </p>
              </div>

              <div className="post-stats">
                <div className="bottom-margin-s">
                  <p className="secondary-text bottom-margin-xs">
                    Florence Health &#183; 10/08/2024
                  </p>
                </div>
              </div>


          <Button type="primary bottom-margin-s" onClick={()=>{navigate('/forum/56')}}>Comentar</Button>
        </div>

        <div className="top-padding-s">
          <p className="heading4 bottom-padding-xs bottom-border">Postagens Relacionadas</p>


              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Elisa Orta &#183; 21/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/141-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Boa tarde. Vou em um rodízio de sushi amanhã, como faço a contagem de carboidratos?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/141')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            3 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Maria de Lourdes &#183; 07/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/40-pressao" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal,<br/>Tenho pressão alta e hoje de manhã fiquei nervosa e ela subiu <br/>Tomei Losartana, hidroclorotiazida um diazepam e um anlodipino e um antidepressivo<br/>Agora a pressão está em 12/7 mas os batimentos cardíacos estão em 107<br/>É normal isso?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/40')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            3 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Pedro Cardoso &#183; 22/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/144-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Boa tarde gente,<br/>minha mãe tem diabetes tipo 2 e vejo ela falando que queria voltar a comer os doces e massas que ela comia antigamente, e ela toma insulina mas parece que não resolve...<br/>Vocês indicam algum remédio?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/144')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            4 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    L. Carrol &#183; 24/07/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/13-geral" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Colesterol Alto: Gorduras boas e ruins  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Na minha trajetória desde que descobri o colesterol alto 3 mudanças foram importantes: perder peso, melhorar minha alimentação e começar a fazer exercício físico. Cada uma delas ajuda a sustentar as outras e a melhorar minha saúde.<br/><br/>Sobre alimentação saudável, em particular, aprendi sobre gorduras boas e ruins para nós.<br/><br/>Gorduras boas: São gorduras mono-saturadas, poli-saturadas, omega-3 e omega-6. Ela diminuem o colesterol ruim (LDL) e aumentam o colesterol bom (HDL). A gente consegue consumir elas em alimentos como nozes, abacates e peixes. Essas são super importantes de comer!<br/><br/>Gorduras para evitar: gordura trans, colesterol e gorduras saturadas.<br/><br/>1) Gordura trans: É a gordura mais perigosa que consumimos. É usada como preservativo para longo tempo de vida útil na prateleira. Deve ser evitada completamente.<br/><br/>2_ Colesterol: Gema de ovo é a principal fonte. Conseguimos evitar comendo somente a clara do ovo.<br/><br/>3) Gordura saturada: Gordura encontrada mais facilmente nas comidas que consumimos. Evitar ao máximo. Ideal buscar comidas com 0g a 0.5g dessa gordura.<br/><br/>O ideal e o que eu tento fazer é evitar e substituir as gorduras ruins por gorduras boas: frutas, vegetais, abacate, nozes, feijão, lentilha e peixe são excelentes opções. É importante utilizar também azeite de oliva ao invés de outros óleos comuns.<br/><br/>Adicionalmente, aprendi os benefícios de evitar carne vermelha, carnes processadas, queijos, manteigas, comidas fritas e que contém muita gordura saturada.<br/><br/>Espero que esse conhecimento seja útil para vocês assim como é para mim!
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/13')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            4 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Tami Costa &#183; 06/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/25-diabetes" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Dúvida hipoglicemia:  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Quanto de glicemia é considerado hipoglicemia? Hoje estava com 75, mas não estava sentindo nada
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/25')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>


        </div>

      </div>
    </div>
  )
}
